<template>
  <div
    class="sticky top-0 z-40 h-14 w-full border-b bg-yapgray-50 transition-colors duration-500 dark:border-yapdarkgray-50/[0.06] dark:bg-yapdarkgray-900"
  >
    <div class="mx-auto flex h-full max-w-[90rem] items-center justify-between px-4 text-sm md:py-0 md:text-sm">
      <!-- Left Hamburger for SideMenu -->
      <div class="-mr-2 flex items-center lg:hidden">
        <button
          type="button"
          class="inline-flex items-center justify-center rounded-md p-0 text-gray-400 hover:bg-gray-100 hover:text-gray-500 dark:bg-yapdarkgray-800 dark:text-yapdarkgray-100"
          @click="state.showingNavigationDropdown = !state.showingNavigationDropdown"
        >
          <YapIcon
            name="menu-outline"
            class="h-6 w-6"
            :class="{
              hidden: state.showingNavigationDropdown,
              'inline-flex': !state.showingNavigationDropdown
            }"
          />
          <YapIcon
            name="close-outline"
            class="h-6 w-6"
            :class="{
              hidden: !state.showingNavigationDropdown,
              'inline-flex': state.showingNavigationDropdown
            }"
          />
        </button>
      </div>

      <slot name="navbar" />
    </div>
  </div>
  <div class="mx-auto max-w-[90rem]">
    <div
      v-if="!!$slots['side-menu']"
      class="translate-x fixed z-40 w-full transition duration-300 lg:z-0 lg:w-80 lg:translate-x-0"
      :class="state.showingNavigationDropdown ? 'translate-x-0' : '-translate-x-full'"
      @click="state.showingNavigationDropdown = false"
    >
      <div class="w-full overflow-y-auto shadow-lg sm:w-[320px] lg:shadow-none" @click.stop>
        <slot name="side-menu" />
      </div>
    </div>
    <div
      class="w-full lg:pr-2"
      :class="{
        'lg:pl-80 lg:pr-2': !!$slots['side-menu']
      }"
    >
      <slot name="content" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive } from 'vue';
import { Theme } from '@/types/general';
import YapIcon from '@/components/YapIcon.vue';
interface State {
  isDarkTheme: boolean;
  showingNavigationDropdown: boolean;
}
const state: State = reactive({
  isDarkTheme:
    localStorage.theme === Theme.DARK_THEME ||
    (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches),
  showingNavigationDropdown: false
});
</script>
